<div class="divCard" [ngClass]="{ divCardFinalize: data.status == 'finalize' }">
  <p class="title">{{ data.title }}</p>
  <p class="total" [ngClass]="{ totalFinalize: data.status == 'finalize' }">
    {{ data.value }}
  </p>
  <div class="displayFlex">
    <div
      class="divPercentage"
      [ngClass]="{
        divPercentageProces: data.status == 'proces',
        divPercentageFinalize: data.status == 'finalize'
      }"
    >
      <mat-icon class="arrow_upward">arrow_upward</mat-icon>
      <p
        class="percentageCreate"
        [ngClass]="{
          percentageProces: data.status == 'proces',
          percentageFinalize: data.status == 'finalize'
        }"
      >
        {{ data.diff }}%
      </p>
    </div>
    <p class="lastMonth">Respecto al último mes</p>
  </div>
  <img
    class="icon"
    [src]="'../../../../../../assets/iconos/' + data.icon"
    alt="icon status"
  />
</div>
